import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=b537603c&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"
import style0 from "./HowTo.vue?vue&type=style&index=0&id=b537603c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b537603c",
  null
  
)

export default component.exports